import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Role = "member" | "admin" | null;

interface AuthState {
  jwt: string | null;
  role: Role;
  userId: string | null;
  email: string | null;
  setMemberJwt: (jwt: string, userId: string) => void;
  setAdminJwt: (jwt: string, email: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      jwt: null,
      role: null,
      userId: null,
      email: null,
      setMemberJwt: (jwt, userId) =>
        set({ jwt, role: "member", userId, email: null }),
      setAdminJwt: (jwt, email) =>
        set({ jwt, role: "admin", email, userId: null }),
      logout: () => set({ jwt: null, role: null, userId: null, email: null }),
    }),
    { name: "yannwo-auth" },
  ),
);
